import { DomEventsSubscribe } from "../../events/dom-events-subscribe";
import { StringHelpers } from "../../helpers/string-helpers";
import { IChartContainer } from "../../models/base/chart-container.interface";
import { ChartRequirementModel } from "../../models/chart-requirement/chart-requirement.model";
import { IComponent } from "../component.interface";

export class SellButtonComponent implements IComponent {
    public id = StringHelpers.newGuid();

    private element: HTMLElement;
    private base: IChartContainer;
    private domEvents: DomEventsSubscribe;
    private chartRequirement = new ChartRequirementModel();
    private plotLineActive = false;
    private requestingSell = false;

    constructor(el: HTMLElement, base: IChartContainer) {
        this.element = el;
        this.base = base;
        this.domEvents = base.domEvents;
        this.onMouseMove();
        this.onMouseDown();
        this.onMouseEnter();
        this.onMouseLeave();
        this.onClick();
        this.onEscPress();
        this.onContextMenuOpen();
        this.subscribeChartRequirmentData();
        this.subscribeAllowSellData();
    }

    private onMouseMove() {
        this.domEvents.onMouseMove(this.id, (event: MouseEvent) => {
            if (!this.base.tiChartSeries || !this.base.tiChartSeries.highStockChart || !this.plotLineActive) {
                return;
            }

            const yAxis = this.base.tiChartSeries.highStockChart.yAxis[0];
            if (!yAxis) {
                return;
            }

            const pointer = this.base.tiChartSeries.highStockChart.pointer.normalize(event);
            const parentElementRect = this.base.tiChartSeries.chartElement.getBoundingClientRect();
            const yTop = pointer.y - parentElementRect.y;

            const yValue = yAxis.toValue(yTop);
            yAxis.removePlotLine('sell-plot-line');
            yAxis.addPlotLine({
                value: yValue,
                id: 'sell-plot-line',
                className: 'sell-plot-line',
                zIndex: 10
            });
        });
    }

    private onMouseDown() {
        this.domEvents.onMouseDown(this.id, (event: MouseEvent) => {
            if (!this.base.tiChartSeries) {
                return;
            }

            if (!this.base.tiChartSeries.highStockChart || !this.plotLineActive || event.which == 3) {
                if (event.which == 3) {
                    this.inActivePlotLine();
                }
                
                return;
            }

            const yAxis = this.base.tiChartSeries.highStockChart.yAxis[0];
            if (!yAxis) {
                return;
            }
            
            const pointer = this.base.tiChartSeries.highStockChart.pointer.normalize(event);
            const parentElementRect = this.base.tiChartSeries.chartElement.getBoundingClientRect();
            const yTop = pointer.y - parentElementRect.y;

            const yValue = yAxis.toValue(yTop);
            this.base.chartService.requestInitiateChartTrade(yValue, false);
            this.inActivePlotLine();
        });
    }

    private onMouseEnter() {
        this.element.addEventListener('mouseenter', () => {
            this.base.chartService.requestBuySellButtonsHover(true, false);
        });
    }

    private onMouseLeave() {
        this.element.addEventListener('mouseleave', () => {
            this.base.chartService.requestBuySellButtonsHover(false, false);
        });
    }

    private onClick() {
        this.element.addEventListener('click', () => {
            this.requestingSell = true;
            this.base.chartService.requestSell();
        });
    }

    private onEscPress() {
        this.domEvents.onEscPress(this.id, () => {
            this.inActivePlotLine();
        });
    }

    private onContextMenuOpen() {
        this.domEvents.onContextMenu(this.id, () => {
            this.inActivePlotLine();
        });
    }

    private inActivePlotLine() {
        if (!this.base.tiChartSeries) {
            return;
        }

        if (this.plotLineActive) {
            const yAxis = this.base.tiChartSeries.highStockChart.yAxis[0];
            yAxis?.removePlotLine('sell-plot-line');
            this.plotLineActive = false;
        }
    }

    private addPlotLine() {
        if (!this.base.tiChartSeries) {
            return;
        }

        const yAxis = this.base.tiChartSeries.highStockChart.yAxis[0];
        if (!yAxis) {
            return;
        }

        if (this.plotLineActive) {
            yAxis.removePlotLine('sell-plot-line');
        } else {
            this.plotLineActive = true;
            yAxis.addPlotLine({
                value: 0,
                id: 'sell-plot-line',
                dashStyle: 'Dash',
                className: 'sell-plot-line',
                zIndex: 10
            });
        }
    }

    private subscribeChartRequirmentData() {
        this.base.chartService.subscribeChartRequirementsData((model: ChartRequirementModel) => {
            this.chartRequirement = model;
            this.toggleButton();
        });
    }

    private subscribeAllowSellData() {
        this.base.chartService.subscribeChartAllowSellData(() => {
            if (!this.requestingSell) {
                return;
            }
            
            this.requestingSell = false;
            this.addPlotLine();
        });
    }

    private toggleButton() {
        if (this.chartRequirement.allShortRequirements) {
            this.element.removeClass('disabled');
            this.element.setAttribute('title', 'Sell with ' + this.chartRequirement.shortAccountName);
        } else {
            this.element.addClass('disabled');
            this.element.setAttribute('title', 'Click to initiate sell');
        }
    }
}